import ScriptEmbed from './ScriptEmbed'

export default ScriptEmbed
